import { useRef } from 'react';
import { useQuery } from '@apollo/client';
import { css } from '@emotion/react';
import { Close } from '@mui/icons-material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Tab, Box, IconButton } from '@mui/material';
import { Image } from '@scorenco/components';
import { useTournamentNewHit } from '@scorenco/core';
import { NextPage } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { Link } from '@/components';
import { AllGamesList } from '../../components';
import { useTournamentStyle } from '../../hooks';
import { TournoisLayout } from '../../layouts';
import { Tournament_GetTournamentDocument, Challenge } from './_internal';
const Home: NextPage = ({
  ...rest
}) => {
  const router = useRouter();
  const tournamentId = Number(router.query.tournamentId);
  const challengeId = Number(router.query.challenge || -1);
  const newHitMutation = useTournamentNewHit();
  const newHitExecuted = useRef(false);
  const tournamentQuery = useQuery(Tournament_GetTournamentDocument, {
    variables: {
      id: tournamentId
    },
    context: {
      role: 'anonymous'
    },
    skip: !tournamentId
  });
  const tournament = tournamentQuery.data?.tournaments_tournament_by_pk;
  const tournamentStyle = useTournamentStyle({
    clubId: tournament?.club_id
  });
  if (!tournament || !tournamentStyle.isReady) {
    return null;
  }
  if (!newHitExecuted.current && tournamentId) {
    newHitMutation.execute({
      tournament_id: Number(tournamentId),
      source: window.self !== window.top ? 'iframe' : 'web'
    });
    newHitExecuted.current = true;
  }
  return <div css={css`
        --color-bg-body: #f6f9fc;
        --color-text-base: #000;

        width: 100%;
        margin-bottom: 2rem;
        padding-top: 3rem;

        ${tournamentStyle.css}
      `} id="top" {...rest} data-sentry-component="Home" data-sentry-source-file="index.page.tsx">
      <Head data-sentry-element="Head" data-sentry-source-file="index.page.tsx">
        <title key="title">{tournament?.name} - Score'n'co</title>
      </Head>
      <TabContext value={`${challengeId}`} data-sentry-element="TabContext" data-sentry-source-file="index.page.tsx">
        <TabList variant="scrollable" scrollButtons="auto" sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        backgroundColor: 'background.default',
        borderBottom: '1px solid',
        borderColor: 'divider'
      }} data-sentry-element="TabList" data-sentry-source-file="index.page.tsx">
          <Tab label="Tous les matchs" value="-1" css={css`
              &.Mui-selected {
                color: #000;
              }
              color: #000;
            `} onClick={event => {
          event.preventDefault();
          router.replace({
            pathname: router.pathname,
            query: {
              tournamentId: tournamentId,
              challenge: -1
            }
          });
        }} data-sentry-element="Tab" data-sentry-source-file="index.page.tsx" />
          {tournament?.challenges?.map(challenge => <Tab key={challenge.id} label={challenge.name} value={`${challenge.id}`} css={css`
                &.Mui-selected {
                  color: #000;
                }
                color: #000;
              `} onClick={event => {
          event.preventDefault();
          router.replace({
            pathname: router.pathname,
            query: {
              tournamentId: tournamentId,
              challenge: challenge.id
            }
          });
          if (challenge.id && tournamentId) {
            newHitMutation.execute({
              tournament_id: Number(tournamentId),
              challenge_id: Number(challenge.id),
              source: window.self !== window.top ? 'iframe' : 'web'
            });
          }
        }} />)}
          <Link href="/" target="_self" style={{
          display: 'flex',
          marginLeft: 'auto'
        }} data-sentry-element="Link" data-sentry-source-file="index.page.tsx">
            <IconButton sx={{
            color: 'primary.main'
          }} data-sentry-element="IconButton" data-sentry-source-file="index.page.tsx">
              <Close data-sentry-element="Close" data-sentry-source-file="index.page.tsx" />
            </IconButton>
          </Link>
        </TabList>
        {tournament?.ad && <Box sx={{
        widht: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: '1rem',
        paddingX: '1rem'
      }}>
            <Image src={tournament.ad} width="750px" style={{
          maxWidth: '100%',
          objectFit: 'contain',
          maxHeight: '187.5px'
        }} />
          </Box>}

        <TabPanel value="-1" css={css`
            padding: 0;
            padding-bottom: 2rem;
          `} data-sentry-element="TabPanel" data-sentry-source-file="index.page.tsx">
          <AllGamesList tournamentId={tournamentId} tournament={tournament} data-sentry-element="AllGamesList" data-sentry-source-file="index.page.tsx" />
        </TabPanel>

        {tournament?.challenges?.map((challenge, idx) => {
        return <TabPanel key={idx} value={`${challenge.id}`} sx={{
          px: 0,
          py: 2
        }}>
              <Challenge challenge={challenge} tournament={tournament} />
            </TabPanel>;
      })}
      </TabContext>
    </div>;
};
export const getStaticProps = TournoisLayout.buildGetStaticProps();
export const getStaticPaths = TournoisLayout.buildGetStaticPaths();
export default Home;